import axios, {AxiosResponse} from 'axios'
import {ManualJounal, UsersQueryResponse} from './_models'
import {ID, Response} from '../../../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/user`
const GET_USERS_URL = `${API_URL}/users/query`
const GET_ACCOUNT_LIST_URL = `${API_URL}/account/list_group`

const getAccounts = (query: string): Promise<UsersQueryResponse> => {
  return axios
    .get(`${GET_ACCOUNT_LIST_URL}?${query}`)
    .then((d: AxiosResponse<UsersQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<ManualJounal | undefined> => {
  return axios
    .get(`${USER_URL}/${id}`)
    .then((response: AxiosResponse<Response<ManualJounal>>) => response.data)
    .then((response: Response<ManualJounal>) => response.data)
}

const createUser = (user: ManualJounal): Promise<ManualJounal | undefined> => {
  return axios
    .put(USER_URL, user)
    .then((response: AxiosResponse<Response<ManualJounal>>) => response.data)
    .then((response: Response<ManualJounal>) => response.data)
}

const updateUser = (user: ManualJounal): Promise<ManualJounal | undefined> => {
  return axios
    .post(`${USER_URL}/${user.id}`, user)
    .then((response: AxiosResponse<Response<ManualJounal>>) => response.data)
    .then((response: Response<ManualJounal>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {getAccounts, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser}
